import { useLiveQuery } from "dexie-react-hooks";
import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import { db } from "~/db/db";
import { useGetUserInfos } from "~components/Request/useRequestQuery";

const chaveUsuario = "usuario-cache";
const chaveVendedor = "vendedor-selecionado-id";

const getUsuarioFromLocalStorage = () => {
  const usuarioStorage = localStorage.getItem(chaveUsuario);

  if (!usuarioStorage) {
    return null;
  }

  try {
    return JSON.parse(usuarioStorage);
  } catch {
    return null;
  }
};

const useUsuario = () => {
  const [enableFetchUser] = useState(true);
  const [usuarioState, setUsuarioState] = useState(getUsuarioFromLocalStorage);

  const usuario = useLiveQuery(() => db.usuario.toCollection().first(), []);

  const { data, refetch, isFetching } = useGetUserInfos(enableFetchUser);
  const { accounts } = useMsal();

  const emailConta = accounts[0]?.username;
  const usuarioDivergente = Boolean(
    data?.data?.email && emailConta && data.data.email.trim().toLowerCase() !== emailConta.trim().toLowerCase()
  );

  useEffect(() => {
    if (usuario === undefined) {
      return;
    }

    if (!usuario) {
      return;
    }

    setUsuarioState((prev) => (prev?.id === usuario.id ? prev : usuario));
    localStorage.setItem(chaveUsuario, JSON.stringify(usuario));
  }, [usuario]);

  useEffect(() => {
    if (data?.data && !usuarioDivergente) {
      setUsuarioState((usuarioAnterior) => {
        const usuarioAnteriorId = usuarioAnterior?.id;
        const usuarioAtualId = data.data?.id;

        if (usuarioAnteriorId && usuarioAtualId && usuarioAnteriorId !== usuarioAtualId) {
          localStorage.removeItem(chaveVendedor);
        }

        return data.data;
      });

      db.transaction("rw", db.usuario, async () => {
        await db.usuario.clear();
        await db.usuario.put(data.data);
      });
      localStorage.setItem(chaveUsuario, JSON.stringify(data.data));
    }
  }, [data, usuarioDivergente]);

  return { usuario: usuario ?? usuarioState, usuarioDivergente, recarregarUsuario: refetch, recarregandoUsuario: isFetching };
};

export default useUsuario
